import React from "react";
import classNames from "classnames";
import { getActivityIcon } from "./activityIcons";
import styles from "./ActivityIcon.module.css";

export const ActivityIcon = ({
  iconType,
  label,
  size = 16,
  className,
  ...props
}) => {
  const iconSrc = getActivityIcon(iconType);

  if (!iconSrc) {
    return null;
  }

  return (
    <img
      src={iconSrc}
      alt={label || iconType}
      className={classNames(styles.activityIcon, className)}
      style={{ width: size, height: size }}
      {...props}
    />
  );
};
